// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__g+3Oq","title":"style__title__rRxna","description":"style__description__2p5UC","component":"style__component__ddP1v"};